<template>
    <div>
        <b-row>
            <b-col cols="12" md="4">
                <ValidationProvider name="academic_year" rules="" v-slot="{valid, errors}">
                    <b-form-group :label="$t('academic_year')">
                        <academic-years-selectbox
                            :validateError="errors[0]"
                            v-model="form.academic_year"
                        >
                        </academic-years-selectbox>
                    </b-form-group>
                </ValidationProvider>
            </b-col>
          <b-col cols="12" md="4">
            <ValidationProvider name="semester" rules="" v-slot="{valid, errors}">
              <b-form-group :label="$t('semester')">
                <parameter-selectbox
                    code="semester"
                    :validateError="errors[0]"
                    v-model="form.semester"
                >
                </parameter-selectbox>
              </b-form-group>
            </ValidationProvider>
          </b-col>
          <b-col cols="12">
            <ValidationProvider name="faculty_code" rules="" v-slot="{valid, errors}">
              <b-form-group :label="$t('faculty')">
                <faculty-selectbox
                    :validateError="errors[0]"
                    v-model="form.faculty_code"
                >
                </faculty-selectbox>
              </b-form-group>
            </ValidationProvider>
          </b-col>
            <b-col cols="12" md="2">
                <b-form-group class="mb-0">
                    <label class="d-none d-md-block">&nbsp;</label>
                    <b-button variant="primary" block @click="getReport">
                        {{ $t('get_report').toUpper() }}
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>
<script>

import AcademicYearsSelectbox from "@/components/interactive-fields/AcademicYearsSelectbox"
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue"
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox.vue"
import qs from "qs";
import FinanceReportService from "@/services/FinanceReportService";

export default {
    components: {
        AcademicYearsSelectbox,
        ParameterSelectbox,
        FacultySelectbox
    },
    data() {
        return {
            form: {
              academic_year: null,
              semester: null,
              faculty_code: null
            }
        }
    },
    methods: {
        getReport(){
            const config = {
                params: {
                    academic_year: this.form.academic_year,
                    semester: this.form.semester,
                    faculty_code: this.form.faculty_code,
                },
                responseType: 'arraybuffer',
                paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }
          FinanceReportService.studentsWithCreditPaymentPlans(config)
                .then(res=>this._downloadFile(res,this.$t('credit_defined_students')+'.xlsx'))
                .catch(err=>this.showErrors(err))
        }
    }
}
</script>
